export const BRAND_PRODUCTS_SECTION_ID = "brand-products-section";
